/* eslint-disable react/jsx-props-no-spreading */
import { Modal } from 'antd';
import './index.css';

// 给antd的modal加上自定义样式 --- 上下border
export const BorderModal = ({ className, ...modalProps }) => {
  const modalClassName = `custom_border_modal ${className || ''}`;

  return (
    <Modal
      className={modalClassName}
      {...modalProps}
    />
  );
};
